import { normalize } from "styled-normalize";
import { createGlobalStyle } from "styled-components";

import { theme } from "./theme";
import { ScreenSize } from "./constants";

export const GlobalStyle = createGlobalStyle`
${normalize};

:root {
  --primary-custom-color: #013C5C;
  --secondary-custom-color: #00B9E0;
  --primary-font-color: #5f6165;
  --primary-font-family: "Poppins", sans-serif !important;
  --body-color-dark: rgba(119, 123, 241, 0.1);
  --body-color: rgba(127, 131, 237, 0.08);
}


* {
  margin: 0 ;
  padding: 0;
  box-sizing: border-box !important;
   text-shadow: rgba(0,0,0,.01) 0 0 1px;
   -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    text-rendering: optimizeLegibility;
}

 html, body, #root {
     font-family: 'Poppins', sans-serif !important;
  }

  html {
    font-size: 8px !important;


   @media (min-width: ${ScreenSize.L}px) {
   font-size: 9px !important;
   }

   @media (min-width: ${ScreenSize.XL}px) {
   font-size: 10px !important;
   }
  }



  p, h1, h2, h3, h4, h5, h6 {
    padding: 0px;
    margin: 0px;

  }

  p {
    font-size: 1.6rem;
    color: #4B4B4B;
    line-height: 25px;
  }

  @media (min-width: ${ScreenSize.L}px) {
    p {
    font-size: 1.6rem;
    color: #4B4B4B;
    line-height: 25px;
    }
  }

  input, select {
    font-size: 1.6rem;
  }

  a {
    text-decoration: none;
    color: #096DD9;
    font-size: 1.6rem;
    font-weight: 500;
  }

  p + p {
    margin-top: 0px !important;
  }

  .ant-table {

   th {
    color: #ffffff !important;
    background-color: ${theme.primary.main} !important;
    font-weight: 600 !important;
    font-size: 13.5px !important;
    text-transform: capitalize !important;
    padding: 14px 12px !important;

   }

   td {
     color: #4B4B4B;
     text-transform: capitalize !important;
     font-size: 13.5px !important;
     font-weight: 400;


     :first-child {

     }

   }

}


.anticon-search {
  color: #ffffff !important;
}

`;
